import React, { useState, useEffect } from 'react';
import {HtmlParse} from 'utils';
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const PersistentCart = (props) => {
    
    const [settings, setSettings] = useState(props.settings);

    useEffect(() => {

        setSettings(props.settings);

    }, [props.settings]);
    
    const _close = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.PersistentCart_CLOSE), 0);
    }

    const cancel = () => {
        _close();
        settings.cancelCallback();
    }

    const confirm = () => {
        _close();
        settings.confirmCallback();
    }

    return (
        <div className="new-modal-container">
            {(settings && settings.title) && <div className='new-modal-title-wrap'><div className="new-modal-title">{HtmlParse(settings.title)}</div></div>}
            <div className='new-modal-scroll'>
                {(settings && settings.message) && <span className="modal-persistentCart-text">{HtmlParse(settings.message)}</span>}
                {(settings && settings.address) && <span className="modal-persistentCart-text">{HtmlParse(settings.address)}</span>}
                {(settings && settings.messageTwo) && <span className="modal-persistentCart-text">{HtmlParse(settings.messageTwo)}</span>}
            </div>
            <div className="modal-actions">
                {(settings && settings.cancelBtnText) && <button className="secundary-btn modal-persistentCart-no-delete-btn" onClick={cancel}>{settings.cancelBtnText}</button>}
                {(settings && settings.confirmBtnText) && <button className={"primary-btn modal-persistentCart-delete-btn" + (settings && !settings.cancelBtnText ? ' unique' : '')} onClick={confirm}>{settings.confirmBtnText}</button>}
            </div>
        </div>
    );
}

PersistentCart.propTypes = {
    settings: PropTypes.object
}

export default PersistentCart;
